import getStorageData from "../../../Utils/getStorageData";
import Spinners from "../../../components/Common/Spinner";
import Request from "../../../helpers/request";
import * as url from "../../../helpers/url_helper";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import RoomControl from "./RoomControl";
import "datatables.net";
import "datatables.net-bs4";

import moment from "moment";
import "../../../assets/scss/custom/pages/_roomcontrol.scss";
// import { getDashoboardPermissions } from '../../../Utils/searchApiCall';

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";
// import "style.css"

const ControlPanel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [roomList, setRoomList] = useState([]);
  const [showRoomControl, setShowRoomControl] = useState(false);
  const [roomSwitchDetail, setRoomSwitchDetail] = useState();
  // const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState<string>("");

  const roomListApiCall = () => {
    setLoading(true);
    // const reqObj = {
    //   length: 10,
    //   premiseId: getStorageData().selectedPremiseID,
    //   start: currentPage === 1 ? 0 : (currentPage - 1) * 10,
    //   search: { value: search, regex: false },
    // };
    const reqObj = {
      length: 1000,
      premiseId: getStorageData().selectedPremiseID,
      start: 0,
      search: { value: search, regex: false },
    };
    Request.post(url.GET_CONTROL_ROOM_LIST_URL, reqObj)
      .then((res) => {
        setRoomList(res.data.data);
        setTotalPages(res.data.recordsTotal);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    roomListApiCall();
  }, [search]);

  const toggleRoomControl = () => {
    setShowRoomControl(!showRoomControl);
  };
  const slugify = (text: string) =>
    text
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  const handleRoomClick = (room: any) => {
    navigate(`/room/${slugify(room.name)}`);
  };

  return (
    <Card
      style={{
        marginTop: 100,
        marginLeft: 30,
        marginRight: 30,
        marginBottom: 0,
        backgroundColor: "#0d1b2a",
      }}
    >
      <CardBody>
        <div className="mb-4 h4 card-title d-flex justify-content-between flex-row">
          <div className="app-search d-lg-block">
            <div className="position-relative">
              <span className="bx bx-search-alt" />
              <input
                type="search"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  background: "#F7F9FC",
                  color: "#858D9D",
                }}
                placeholder={"Search..."}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        {loading && <AirHomeLoader />}
        {/* {loading ? <div style={{ height: "60vh" }}><Spinners /></div>
                    : */}
        {roomList.length === 0 && !loading ? (
          <div style={{ height: "60vh", textAlign: "center" }}>
            <h4 style={{ color: "#667085" }}>No Rooms Available</h4>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              {roomList.map((item: any, index: number) => {
                const checkOutDate =
                  item?.guestCheckOut && item?.guestCheckIn
                    ? `${moment(item?.guestCheckIn)
                        .local()
                        .format("DD/MM")} to ${moment(item?.guestCheckOut)
                        .local()
                        .format("DD/MM")}`
                    : "";
                return (
                  <Row key={index}>
                    <Col
                      md={3}
                      style={{ marginRight: 16 }}
                      onClick={() => {
                        toggleRoomControl();
                        setRoomSwitchDetail(item);
                        handleRoomClick(item);
                      }}
                    >
                      <Card
                        body
                        className="room-list border"
                        style={{
                          backgroundColor: "#E7F8F0",

                          // margin: 0,
                        }}
                      >
                        <h1
                          className="room-name-font"
                          style={{
                            fontSize: 16,
                            color: "#858D9D",
                            fontWeight: "600",
                          }}
                        >
                          {item?.name.length > 10
                            ? `${item?.name.slice(0, 10)}...`
                            : item?.name}
                        </h1>

                        <h6
                          className="guest-name-font"
                          style={{ fontSize: 16 }}
                        >
                          {checkOutDate}
                        </h6>
                        <h6
                          style={{
                            fontSize:
                              !item.guestName && !item.checkOutDate ? 16 : 12,
                            color: "#858D9D",
                            fontWeight: "400",
                          }}
                        >
                          {item.guestStatus === 0 ? "Available" : "Booked"}
                        </h6>
                      </Card>
                    </Col>
                  </Row>
                );
              })}
            </div>
            {/* {roomList.length === 0 ? (
              ""
            ) : (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Paginations
                  perPageData={10}
                  data={totalPages}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  isShowingPageLength={false}
                  paginationDiv="col-12"
                  paginationClass="pagination pagination justify-content-center mt-2 mb-5"
                />
              </div>
            )} */}
          </div>
        )}
        {/* </table>)} */}
        {/* {showRoomControl && (
          <RoomControl
            roomSwitchDetail={roomSwitchDetail}
            showRoomControl={showRoomControl}
            toggleRoomControl={() => toggleRoomControl()}
          />
        )} */}
      </CardBody>
    </Card>
  );
};

export default ControlPanel;
